var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chip-demo"}},[_c('chip-default'),_c('chip-color'),_c('chip-icon'),_c('chip-closable'),_c('chip-add-remove'),_c('chip-customize-close-clear-chip-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }